import { useMemo } from 'react';
import { MEDIA_WIDTHS } from 'theme';

import useWindowSize from './useWindowSize';

const useIsMobileLayout = () => {
  const { width } = useWindowSize();

  return useMemo(() => (width ? width <= MEDIA_WIDTHS.upToMedium : false), [width]);
};

export default useIsMobileLayout;
